// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__TWmj2","mobile":"MainHeader_mobile__hzeLX","desktop":"MainHeader_desktop__D02ah"};